/*
  JILZARAH — Faith & Inspiration page: presentation only (custom, not part of Flex)

  The shopping itself — quantities, stock caps, the one-request add, tabs, the pinned strip,
  the product drawer — is the shared engine, assets/jilzarah-outlet.js, used unchanged.
  This file adds what is this page's own: the wording of the "Your selection" bar
  (sections/jilzarah-faith-shop.liquid), and one nicety for phones at the bottom.

  After every engine render ("jzo:render") it reads the engine's pending quantities and
  writes "1 collection + 2 bracelets" and the subtotal, and shows the bar only while
  something is chosen. The engine's own summary line is "3 items · $272.00"; this page words
  it by kind (kits and individual products), which the engine knows nothing about, so the
  markup carries data-jzf-kind on each item and the unit names on the shop element. The
  bar's button is the engine's ordinary [data-jzo-add-selected].

  Nothing here talks to the cart.
*/
(function () {
  'use strict';
  if (window.JZFaith) return;
  window.JZFaith = true;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function plural(n, one, many) { return n === 1 ? one : many; }

  function renderBar(shop) {
    var bar = shop.querySelector('[data-jzf-bar]'), E = window.JZOutlet;
    if (!bar || !E) return;
    var packs = 0, singles = 0, sub = 0, priced = true, seen = {};
    shop.querySelectorAll('[data-jzo-item]').forEach(function (it) {
      var vid = it.dataset.jzoItem, q = E.pending[vid] || 0, p = E.products[vid];
      if (!(q > 0) || !p || seen[vid]) return;
      seen[vid] = 1;
      if (it.dataset.jzfKind === 'pack') packs += q; else singles += q;
      if (typeof p.price === 'number') sub += p.price * q; else priced = false;
    });
    var d = shop.dataset, parts = [];
    if (packs) parts.push(packs + ' ' + plural(packs, d.jzfPack || 'collection', d.jzfPacks || 'collections'));
    if (singles) parts.push(singles + ' ' + plural(singles, d.jzfUnit || 'item', d.jzfUnits || 'items'));
    var count = bar.querySelector('[data-jzf-count]'), total = bar.querySelector('[data-jzf-total]');
    var text = parts.join(' + ');
    if (count && count.textContent !== text) count.textContent = text;
    if (total) total.textContent = priced && parts.length ? money(sub) : '';
    bar.hidden = !parts.length;
  }

  /* arriving on a later tab (#communion-confirmation) on a phone: bring its pill into view in the
     swipeable strip, once. The row is moved sideways only; the page does not scroll. */
  var centred = false;
  function centreActivePill() {
    if (centred) return;
    var row = document.querySelector('.jzf--strip .jzo-nav__in'), a = row && row.querySelector('a.is-active');
    if (!row || !a) return;
    centred = true;
    var r = row.getBoundingClientRect(), b = a.getBoundingClientRect();
    if (b.left < r.left || b.right > r.right) row.scrollLeft += b.left - r.left - (r.width - b.width) / 2;
  }

  document.addEventListener('jzo:render', function () {
    document.querySelectorAll('[data-jzf-shop]').forEach(renderBar);
    centreActivePill();
  });
})();
